import React, { Fragment, useEffect, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import '../../../../assets/scss/preview.css';
import { ptwFormApi } from '../../../../api/ptwForm.api.ts';
import CustomNumber from '../../../Common/customComponents/CustomNumber.tsx';
import CustomRadioSingle from 'containers/Common/customComponents/CustomRadioSingle.tsx';
import CustomText from '../../../Common/customComponents/CustomText.tsx';
import CustomCheck from '../../../Common/customComponents/CustomCheck.tsx';
import FormTabXBlack from '/assets/icon/global/form-tab-x-black.svg';
import DeviceRegisterModal from '../modal/DeviceRegisterModal.tsx';
import JhaSearchModal from '../modal/JhaSearchModal.tsx';

interface IProps {
  formCode: string;
  handleChange: (e: any) => void;
  data?: any;
  isReadOnly?: any;
}

const PermitIssueForm = (props: IProps) => {
  const [formInfo, setFormInfo] = useState<any>({});
  const [workRiskCount, setWorkRiskCount] = useState<number>(0);
  useEffect(() => {
    if (!props.formCode) return;
    //console.log(1212, props.data)
    if (props.data.iotDeviceList) {
      setCctvList(props.data.iotDeviceList.cctv);
      setGasDetactorList(props.data.iotDeviceList.gasDetector);
      setSmartHookList(props.data.iotDeviceList.smartHook);
    }
  }, [props.data]);
  useEffect(() => {
    if (!props.formCode) return;
    ptwFormApi.getPtwFormInfo(props.formCode).then((res) => {
      var formInfo = res.resultObject;
      var highRiskCount = 0;
      for (var s in formInfo.sections) {
        var section = formInfo.sections[s];
        if (section.highRisk === true) {
          for (var i in section.items) {
            var item = section.items[i];
            if (props.data.formData && props.data.formData[item.itemName] === true) {
              highRiskCount++;
            }
          }
        }
      }
      setFormInfo(formInfo);
      setWorkRiskCount(highRiskCount);
    });
  }, [props.formCode]);
  const _handleChange = (e: any) => {
    e.target.safDataType = 'saf-form-data';
    if (e.target.isHighRiskItem) {
      var _workRiskCount = workRiskCount;
      if (e.target.value === true) {
        _workRiskCount = _workRiskCount + 1;
      } else {
        _workRiskCount = _workRiskCount - 1;
      }
      setWorkRiskCount(_workRiskCount);
      const workRisk = _workRiskCount > 0 ? 'HIGH' : 'GENERAL';
      props.handleChange({
        target: { name: 'workRisk', value: workRisk }
      });
    }
    props.handleChange(e);
  };
  //
  const [cctvList, setCctvList] = useState<any[]>([]);
  const [gasDetectorList, setGasDetactorList] = useState<any[]>([]);
  const [smartHookList, setSmartHookList] = useState<any[]>([]);
  const [isDeviceRegisterModalOpen, setIsDeviceRegisterModalOpen] = useState<boolean>(false);
  const [gubun, setGubun] = useState<string>('cctv');
  const [isSpCmSearchModalOpen, setSpCmSearchModalOpen] = useState<boolean>(false);
  useEffect(() => {
    if (!props.data?.cctvData) return;
    if (props.data?.cctvData) {
      setCctvList(props.data.cctvData);
    }
  }, [props.data?.cctvData]);

  useEffect(() => {
    if (!props.data?.gasDetectorData) return;
    if (props.data?.gasDetectorData) {
      setGasDetactorList(props.data.gasDetectorData);
    }
  }, [props.data?.gasDetectorData]);

  useEffect(() => {
    if (!props.data?.smartHookData) return;
    if (props.data?.smartHookData) {
      setSmartHookList(props.data.smartHookData);
    }
  }, [props.data?.smartHookData]);

  const deleteCctvItem = (item: any) => {
    const updated = cctvList.filter((i) => i.deviceId !== item.deviceId);
    setCctvList(updated);
    props.data.iotDeviceList[gubun] = updated;
  };

  const deleteGasDetectorItem = (item: any) => {
    const updated = gasDetectorList.filter((i) => i.deviceId !== item.deviceId);
    setGasDetactorList(updated);
    props.data.iotDeviceList[gubun] = updated;
  };

  const deleteSmartHookItem = (item: any) => {
    const updated = smartHookList.filter((i) => i.deviceId !== item.deviceId);
    setSmartHookList(updated);
    props.data.iotDeviceList[gubun] = updated;
  };

  const deviceRegisterModalCallback = (checkedMap: Record<string, any[]>) => {
    if (!checkedMap) return;

    if (props.data.iotDeviceList === undefined) {
      props.data.iotDeviceList = {};
    }

    Object.entries(checkedMap).forEach(([key, data]) => {
      const existing = props.data.iotDeviceList[key] || [];
      const merged = [
        ...existing,
        ...data.filter(
          (newItem: any) => !existing.some((exItem: any) => exItem.deviceId === newItem.deviceId)
        )
      ];
      props.data.iotDeviceList[key] = merged;

      if (key === 'cctv') setCctvList(merged);
      else if (key === 'gasDetector') setGasDetactorList(merged);
      else if (key === 'smartHook') setSmartHookList(merged);
    });
  };

  const openDeviceRegisterModal = (gubun: string) => {
    setGubun(gubun);
    setIsDeviceRegisterModalOpen(true);
  };

  const sPcmCallback = (data: any) => {
    props.handleChange({ target: { name: 'sPcm', value: data.settingJhaSeq } });
    props.handleChange({ target: { name: 'sPcmJhaNo', value: data.jhaNo } });
    setSpCmSearchModalOpen(false);
  };

  return (
    <div>
      <JhaSearchModal
        setIsModalOpen={setSpCmSearchModalOpen}
        isModalOpen={isSpCmSearchModalOpen}
        title={'Add S-PCM'}
        columnHeaderLabel={'S-PCM No'}
        categorySeq={3}
        onActionCallback={sPcmCallback}
      />
      <DeviceRegisterModal
        setIsModalOpen={setIsDeviceRegisterModalOpen}
        isModalOpen={isDeviceRegisterModalOpen}
        onActionCallback={deviceRegisterModalCallback}
        targetPtwDSeq={props.data?.ptwDSeq}
        gubun={gubun}
        iotDeviceList={props.data?.iotDeviceList}
      />
      {formInfo?.sections?.map((section: any, si: number) => {
        if (section.renderType === 'BASE' || section.renderType === 'APPR') return null;
        var prevGroupLabels = [];
        if (section.renderType === 'LIST_GROUP') {
          for (var i in section.items) {
            var item = section.items[i];
            if (prevGroupLabels.indexOf(item.groupLabel) === -1) {
              prevGroupLabels.push(item.groupLabel);
            }
          }
        }
        return (
          <div key={si}>
            {section.renderType.indexOf('LIST_UNIT') > -1 && (
              <Fragment>
                <div className="form-sub-title">{section.label}</div>
                <div className="form-grid-2">
                  {section.items?.map((item: any, ii: number) => (
                    <div className="form-grid-item" key={ii}>
                      <div className={'form-grid-item-label'}>{item.label}</div>
                      <div className={'form-grid-item-input'}>
                        <CustomNumber key={ii} name={item.itemName} onChange={_handleChange} />
                      </div>
                      <div className={'form-grid-item-unit'}>{item.unit}</div>
                    </div>
                  ))}
                </div>
              </Fragment>
            )}
            {section.renderType.indexOf('LIST_YNNAR') > -1 && (
              <>
                <div className="form-sub-title">{section.label}</div>
                <table className="form-table">
                  <thead>
                    <tr>
                      <th>List</th>
                      <th className="text-align-center">YES</th>
                      <th className="text-align-center">NO</th>
                      <th className="text-align-center">N/A</th>
                      <th className="text-align-center">Remarks</th>
                    </tr>
                  </thead>
                  <tbody>
                    {section.items?.map((item: any, ii: number) => {
                      var addRender = item.addRender;
                      var addRenderType = null;
                      var addRenderLabels = [];
                      if (addRender) {
                        addRenderType = addRender['TYPE'];
                        addRenderLabels = addRender['LABELS'];
                      }
                      //console.log(111, props?.data?.formData[item.itemName + '-REMARKS']);
                      return (
                        <tr key={ii}>
                          <td>{item.label}</td>
                          <td className="text-align-center">
                            <CustomRadioSingle
                              name={item.itemName}
                              selectedValue={
                                props.data.formData && props.data.formData[item.itemName]
                              }
                              value="Y"
                              onChange={_handleChange}
                              readOnly={props.isReadOnly}
                              disabled={props.isReadOnly}
                            />
                          </td>
                          <td className="text-align-center">
                            <CustomRadioSingle
                              name={item.itemName}
                              selectedValue={
                                props.data.formData && props.data.formData[item.itemName]
                              }
                              value="N"
                              onChange={_handleChange}
                              readOnly={props.isReadOnly}
                              disabled={props.isReadOnly}
                            />
                          </td>
                          <td className="text-align-center">
                            <CustomRadioSingle
                              name={item.itemName}
                              selectedValue={
                                props.data.formData && props.data.formData[item.itemName]
                              }
                              value="NA"
                              onChange={_handleChange}
                              readOnly={props.isReadOnly}
                              disabled={props.isReadOnly}
                            />
                          </td>
                          <td>
                            {addRenderType === 'REMARK_PRE_TEXT'
                              ? item.addRender['TEXT'] + ' '
                              : ''}
                            {addRenderType === 'REMARK_CHECK' &&
                              addRenderLabels?.map((__item: any, __i: number) => (
                                <div key={__i} style={{ marginBottom: '3px' }}>
                                  <CustomCheck
                                    label={__item}
                                    name={item.itemName + '-REMARKS-' + __i}
                                    checked={
                                      props.data.formData &&
                                      props.data.formData[item.itemName + '-REMARKS-' + __i]
                                    }
                                    onChange={function (e: any) {
                                      _handleChange(e);
                                    }}
                                    readOnly={props.isReadOnly}
                                    disabled={props.isReadOnly}
                                  />
                                </div>
                              ))}
                            {addRenderType !== 'REMARK_CHECK' && (
                              <CustomText
                                name={item.itemName + '-REMARKS'}
                                className="form permit-input-item"
                                value={
                                  props.data.formData &&
                                  props.data.formData[item.itemName + '-REMARKS']
                                }
                                onChange={_handleChange}
                                readOnly={props.isReadOnly}
                              />
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </>
            )}
            {section.renderType.indexOf('GRID') > -1 && (
              <Fragment>
                <div className="form-sub-title">{section.label}</div>
                <div className={'form-check-area ' + (section.accentInput ? ' form-accent' : '')}>
                  {section.items?.map((item: any, ii: number) => {
                    return (
                      <div className={'form-check-area-item'} key={ii}>
                        <CustomCheck
                          label={item.label}
                          name={item.itemName}
                          checked={props.data.formData && props.data.formData[item.itemName]}
                          onChange={function (e: any) {
                            if (section.highRisk === true) {
                              e.target.isHighRiskItem = true;
                            }
                            _handleChange(e);
                          }}
                          readOnly={props.isReadOnly}
                          disabled={props.isReadOnly}
                        />
                        {item.type === 'CHECKBOX_TEXT' && (
                          <CustomText
                            name={item.itemName + '-REMARKS'}
                            className="add-input"
                            value={
                              props.data.formData && props.data.formData[item.itemName + '-REMARKS']
                            }
                            onChange={_handleChange}
                            readOnly={props.isReadOnly}
                          />
                        )}
                      </div>
                    );
                  })}
                </div>
                {section.highRisk === true ? (
                  <Fragment>
                    <table className={'form-table'}>
                      <tbody>
                        <tr>
                          <th>S-PCM</th>
                          <td>
                            <CustomText
                              name={'sPcmJhaNo'}
                              className={'form'}
                              onChange={props.handleChange}
                              value={props.data?.sPcmJhaNo}
                              isBtnSearch={
                                props.data?.workRisk == 'HIGH' ? !props.isReadOnly : false
                              }
                              onSearchAction={() => {
                                setSpCmSearchModalOpen(true);
                              }}
                              readOnly={true}
                            />
                          </td>
                        </tr>
                        <tr>
                          <th>CCTV</th>
                          <td>
                            <div
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                width: '100%'
                              }}
                            >
                              <div style={{ flex: '0 0 150px' }}>
                                <CustomNumber
                                  onChange={props.handleChange}
                                  name="cctv"
                                  className="form"
                                  value={props.data?.cctv}
                                  defaultValue={0}
                                  readOnly={
                                    props.data?.workRisk == 'HIGH' ? props.isReadOnly : true
                                  }
                                />
                              </div>

                              {(props.data?.workRisk == 'HIGH' ? !props.isReadOnly : false) && (
                                <div
                                  className="action-button"
                                  onClick={() => {
                                    openDeviceRegisterModal('cctv');
                                  }}
                                  style={{ cursor: 'pointer', fontSize: '15px' }}
                                >
                                  + Register
                                </div>
                              )}
                            </div>
                            <div className="work-select-multi">
                              {cctvList?.map((item, index) => (
                                <div className="selected-item" key={index}>
                                  <span>{item.deviceName}</span>

                                  {!props.isReadOnly && (
                                    <a onClick={() => deleteCctvItem(item)}>
                                      <img
                                        src={FormTabXBlack}
                                        alt="close"
                                        style={{ width: '15px', height: '15px' }}
                                      />
                                    </a>
                                  )}
                                </div>
                              ))}
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <th>Gas Detector</th>
                          <td>
                            <div
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                width: '100%'
                              }}
                            >
                              <div style={{ flex: '0 0 150px' }}>
                                <CustomNumber
                                  onChange={props.handleChange}
                                  name="gasDetector"
                                  className="form"
                                  value={props.data?.gasDetector}
                                  defaultValue={0}
                                  readOnly={
                                    props.data?.workRisk == 'HIGH' ? props.isReadOnly : true
                                  }
                                />
                              </div>

                              {(props.data?.workRisk == 'HIGH' ? !props.isReadOnly : false) && (
                                <div
                                  className="action-button"
                                  onClick={() => {
                                    openDeviceRegisterModal('gasDetector');
                                  }}
                                  style={{ cursor: 'pointer', fontSize: '15px' }}
                                >
                                  + Register
                                </div>
                              )}
                            </div>
                            <div className="work-select-multi">
                              {gasDetectorList?.map((item, index) => (
                                <div className="selected-item" key={index}>
                                  <span>{item.deviceName}</span>
                                  {!props.isReadOnly && (
                                    <a onClick={() => deleteGasDetectorItem(item)}>
                                      <img
                                        src={FormTabXBlack}
                                        alt="close"
                                        style={{ width: '15px', height: '15px' }}
                                      />
                                    </a>
                                  )}
                                </div>
                              ))}
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <th>Smart Hook</th>
                          <td>
                            <div
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                width: '100%'
                              }}
                            >
                              <div style={{ flex: '0 0 150px' }}>
                                <CustomNumber
                                  onChange={props.handleChange}
                                  name="smartHook"
                                  className="form"
                                  value={props.data?.smartHook}
                                  defaultValue={0}
                                  readOnly={
                                    props.data?.workRisk == 'HIGH' ? props.isReadOnly : true
                                  }
                                />
                              </div>

                              {(props.data?.workRisk == 'HIGH' ? !props.isReadOnly : false) && (
                                <div
                                  className="action-button"
                                  onClick={() => {
                                    openDeviceRegisterModal('smartHook');
                                  }}
                                  style={{ cursor: 'pointer', fontSize: '15px' }}
                                >
                                  + Register
                                </div>
                              )}
                            </div>
                            <div className="work-select-multi">
                              {smartHookList?.map((item, index) => (
                                <div className="selected-item" key={index}>
                                  <span>{item.deviceName}</span>

                                  {!props.isReadOnly && (
                                    <a onClick={() => deleteSmartHookItem(item)}>
                                      <img
                                        src={FormTabXBlack}
                                        alt="close"
                                        style={{ width: '15px', height: '15px' }}
                                      />
                                    </a>
                                  )}
                                </div>
                              ))}
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </Fragment>
                ) : (
                  <></>
                )}
              </Fragment>
            )}
            {section.renderType.indexOf('LIST_GROUP') > -1 && (
              <Fragment>
                <div className="form-sub-title">{section.label}</div>
                <div className={'form-check-area ' + (section.accentInput ? ' form-accent' : '')}>
                  {prevGroupLabels?.map((groupLabel: any, gi: number) => (
                    <div key={gi}>
                      <div className={'saf-bold'}>{groupLabel} :</div>
                      <div className="form-check-area noline">
                        {section.items?.map((item: any, ii: number) => {
                          if (item.groupLabel === groupLabel) {
                            return (
                              <div className={'form-group-item'} key={ii}>
                                <CustomCheck
                                  key={ii}
                                  label={item.label}
                                  name={item.itemName}
                                  checked={
                                    props.data.formData && props.data.formData[item.itemName]
                                  }
                                  onChange={_handleChange}
                                  readOnly={props.isReadOnly}
                                  disabled={props.isReadOnly}
                                />
                                {item.type === 'CHECKBOX_TEXT' && (
                                  <CustomText
                                    name={item.itemName + '-REMARKS'}
                                    className="add-input"
                                    value={
                                      props.data.formData &&
                                      props.data.formData[item.itemName + '-REMARKS']
                                    }
                                    onChange={_handleChange}
                                    readOnly={props.isReadOnly}
                                  />
                                )}
                              </div>
                            );
                          } else {
                            return null;
                          }
                        })}
                      </div>
                    </div>
                  ))}
                </div>
              </Fragment>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default PermitIssueForm;
